module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_plan_show_bg_01-7312dbb656990f061ecd2734fd2b7545.jpg";